<template>
  <component :is="component" />
</template>

<script>
import Setting from './Setting';

export default Setting;
</script>

<style lang="scss" scoped>
@import 'Setting';
</style>
